import type { DOMOutputSpec, Node, Node as ProsemirrorNode, NodeSpec } from 'prosemirror-model';

import type { Placeholder } from '@core/wysiwyg-legacy';

import { NodeName } from '../../schema/nodes';

export class PlaceholderNode implements NodeSpec {
  public static readonly nodeName = NodeName.Placeholder;
  public static is(node: ProsemirrorNode) {
    return node.type.name === PlaceholderNode.nodeName;
  }
  public placeholders: Placeholder[];
  public attrs = {
    'data-active-placeholder-id': {},
    'data-active-placeholder-value': {},
  };
  public inline = true;
  public atom = true;
  public content = 'inline+';
  public group = 'inline';
  public selectable = false;
  public draggable = false;
  public defining = true;
  public parseDOM = [
    {
      tag: 'span[data-component-type="placeholder-item"]',
      getAttrs: (node: HTMLElement) => ({
        'data-active-placeholder-id': node.dataset['activePlaceholderId'],
        'data-active-placeholder-value': node.dataset['activePlaceholderValue'],
      }),
    },
  ];

  public toDOM = (node: Node): DOMOutputSpec => [
    'span',
    {
      'data-active-placeholder-id': node.attrs['data-active-placeholder-id'],
      'data-active-placeholder-value': node.attrs['data-active-placeholder-value'],
      'data-component-type': 'placeholder-item',
    },
    node.attrs['data-active-placeholder-value'],
  ];
}
